<div class="youtube-video-modal">
  <button type="button" class="btn-close-video" aria-label="Close video" (click)="activeModal.dismiss()">
    <span class="material-symbols-outlined">close</span>
  </button>
  <div class="ratio ratio-16x9">
    <iframe #player [src]="videoUrl" [title]="videoTitle"
      allow="autoplay; encrypted-media; picture-in-picture; fullscreen" (load)="onPlayerLoad()"></iframe>
  </div>
</div>
